<template>
  <confirm-modal
    :show-modal.sync="showModalInternal"
    :title="displayedTitle"
    @close="$emit('close')"
    @confirm="$emit('confirm')"
    :confirm-button-color="confirmButtonColor"
    :confirm-button-label="confirmButtonLabel"
  >
    <slot ></slot>
  </confirm-modal>
</template>

<script>
import {LocaleUtils} from '../utils/locale-utils';
import ConfirmModal from './ConfirmModal';

export default {
  name: 'ConfirmDeletionModal',
  components: {ConfirmModal},
  mixins: [
    LocaleUtils,
  ],
  props: {
    showModal: null,
    title: null,
    confirmButtonColor: {
      default () {
        return 'error';
      }
    },
    confirmButtonLabel: {
      default () {
        return this.$t('general.delete');
      }
    }
  },
  data () {
    return {
      showModalInternal: false
    }
  },
  computed: {
    displayedTitle() {
      return this.title || this.trans('general.delete');
    }
  },
  watch: {
    showModal (showModal) {
      this.showModalInternal = showModal;
    },
    showModalInternal (showModalInternal) {
      this.$emit('update:show-modal', showModalInternal);
    }
  }
}
</script>
